/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Waffo_Product_Ids_MappingInputs */

const en_admin_settings_fields_waffo_product_ids_mapping = /** @type {(inputs: Admin_Settings_Fields_Waffo_Product_Ids_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product IDs Mapping`)
};

/**
* | output |
* | --- |
* | "Product IDs Mapping" |
*
* @param {Admin_Settings_Fields_Waffo_Product_Ids_MappingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_waffo_product_ids_mapping = /** @type {((inputs?: Admin_Settings_Fields_Waffo_Product_Ids_MappingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Waffo_Product_Ids_MappingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_waffo_product_ids_mapping(inputs)
});
export { admin_settings_fields_waffo_product_ids_mapping as "admin.settings.fields.waffo_product_ids_mapping" }